"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAURegionCode = exports.isUSRegionCode = exports.isCARegionCode = exports.toCountryCode = exports.getCountryCodeFromOrganizationCountry = exports.REGION_REGISTRY = void 0;
const country_region_data_1 = __importDefault(require("country-region-data"));
const country_1 = require("../enums/country");
const types_1 = require("./types");
const DISPLAY_NAME_OVERRIDES = {
    [country_1.CountryCode.CA]: {
        QC: "Québec",
    },
};
const buildRegistry = () => {
    const registry = new Map();
    for (const country of country_region_data_1.default) {
        const countryCode = country.countryShortCode;
        const overrides = DISPLAY_NAME_OVERRIDES[countryCode] ?? {};
        const entries = country.regions
            .filter((region) => region.shortCode)
            .map((region) => ({
            code: region.shortCode,
            displayName: overrides[region.shortCode] ?? region.name,
        }));
        registry.set(countryCode, entries);
    }
    return registry;
};
exports.REGION_REGISTRY = buildRegistry();
const getCountryCodeFromOrganizationCountry = (country) => country_1.ORGANIZATION_COUNTRY_MAP[country].countryCode;
exports.getCountryCodeFromOrganizationCountry = getCountryCodeFromOrganizationCountry;
const toCountryCode = (country) => {
    if (!country) {
        return undefined;
    }
    if (country in country_1.OrganizationCountry) {
        return (0, exports.getCountryCodeFromOrganizationCountry)(country);
    }
    return country;
};
exports.toCountryCode = toCountryCode;
const isCARegionCode = (code) => types_1.CA_REGION_CODES.includes(code);
exports.isCARegionCode = isCARegionCode;
const isUSRegionCode = (code) => types_1.US_REGION_CODES.includes(code);
exports.isUSRegionCode = isUSRegionCode;
const isAURegionCode = (code) => types_1.AU_REGION_CODES.includes(code);
exports.isAURegionCode = isAURegionCode;
